import { get, isEmpty } from 'lodash';
import * as toolSelectors from '../../selectors/tools';
import { extractSelectedTicketIdFromState, getSimplrAccountIdOfSelectedTicket } from 'extractFromState';
import { simplrOrderPostQuery } from '../../api/orders/simplrOrder';
import { setSubscriptions } from 'actions/tools/CommonSubscriptionActions';

export const cancelSubscriptionsFromDecisionTreeViaSimplrOrder =
  (cancellationReason, cancellationNote) => async (dispatch, getState) => {
    const state = getState();
    const simplrAccountId = getSimplrAccountIdOfSelectedTicket(state);
    const selectedSubscriptions = toolSelectors.getSelectedSubscriptionList(state);
    const conversationId = extractSelectedTicketIdFromState(state);

    if (isEmpty(selectedSubscriptions)) {
      throw new Error('No selected subscription');
    }

    await Promise.all(
      selectedSubscriptions.map((subscription) => {
        const params = {
          simplrAccountId,
          conversationId,
          domain: get(subscription, 'simplrParams.domain'),
          brandName: get(subscription, 'simplrParams.brandName'),
          cancellationReason,
          subscriptionId: subscription.id,
          cancellationNote,
        };

        return simplrOrderPostQuery('/subscription', params);
      })
    );
    dispatch(setSubscriptions([]));
  };
